import PropTypes from 'prop-types'
import { DetailsContainer as Container } from '@calendly/booking-kit'
import styled from 'astroturf/react'
import _StyledDetails from "index-StyledDetails.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/new_confirmation/details/index.js?styleId=StyledDetails";

const colorGrey3 = 'var(--color-grey-3, #CCCCCC)'

const StyledDetails = /*#__PURE__*/styled('div', null, {
  displayName: "StyledDetails",
  styles: _StyledDetails
})

const Details = ({ flow = 'column', ...props }) => (
  <StyledDetails>
    <Container data-container="details" flow={flow} {...props} />
  </StyledDetails>
)

Details.propTypes = {
  flow: PropTypes.oneOf(['column', 'row'])
}

export default Details
